var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"10","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M7.724 0l1.651 1.65-5.448 5.352 5.448 5.348L7.725 14l-7.1-6.998L7.725 0z","fill":"#974900"}})])}
var staticRenderFns = []

export { render, staticRenderFns }